import {initialState as auth} from "../reducers/auth";
import {initialState as utils} from "../reducers/utils";
import {initialState as languages} from "../reducers/languages";
import {initialState as moderators} from "../reducers/moderators";
import {initialState as staticTexts} from "../reducers/staticTexts";
import {initialState as media} from "../reducers/media";
import {initialState as composite} from "../reducers/composite";
import {initialState as slider} from "../reducers/slider";
import {initialState as partner} from "../reducers/partner";
import {initialState as general} from "../reducers/general";
import {initialState as subscribers} from "../reducers/subscribers";
import {initialState as about} from "../reducers/about";
import {initialState as services} from "../reducers/services";
import {initialState as product} from "../reducers/product";
import {initialState as news} from "../reducers/news";
import {initialState as home} from "../reducers/home";
import {initialState as request} from "../reducers/requests";
import {initialState as orderRequest} from "../reducers/order-requests";
import {initialState as block} from "../reducers/block";
import {initialState as info} from "../reducers/info";


const reducers = {
    auth,
    utils,
    languages,
    moderators,
    staticTexts,
    media,
    composite,
    slider,
    partner,
    general,
    subscribers,
    about,
    services,
    product,
    news,
    home,
    request,
    orderRequest,
    block,
    info
};

export default state => {
    const sData = {};
    Object.keys(reducers).forEach(selectorKey => {
        Object.keys(reducers[selectorKey]).forEach(key => {
            sData[key] = state[selectorKey][key];
        });
    });
    return sData;
};

